import { MAX_PARTNERS_BY_DRAFTS } from 'constants/defaultConstants';
import { getStockPlans } from 'modules/beneficiaries/redux/planActions';
import { useGetPartners } from 'modules/partners/hooks/useGetPartners';
import { getHoldingClasses } from 'modules/partners/redux/holdingClassActions';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { State } from 'redux/initialState';
import { useGetActualSociety } from 'hooks/useGetActualSociety';
import { getTenderOffers } from 'modules/transactions/redux/tenderOfferActions';
import { getDrafts } from '../redux/draftActions';

type UseDraftSellParticipationsProps = {
  societyId: string;
};

const useDraftSellParticipations = ({
  societyId,
}: UseDraftSellParticipationsProps) => {
  const dispatch = useDispatch();

  const actualSociety = useSelector(
    (state: State) => state?.society?.actualSociety
  );
  const drafts = useSelector((state: State) => state?.drafts);
  const holdingClasses = useSelector((state: State) => state?.holdingClasses);
  const investors = useSelector(
    (state: State) => state?.society?.actualSociety?.investors
  );
  const operations = useSelector((state: State) => state?.operations);
  const partners = useSelector((state: State) => state?.partners);
  const plans = useSelector((state: State) => state?.plans);
  const tenderOffers = useSelector((state: State) => state?.tenderOffers);

  useGetActualSociety(societyId);

  useGetPartners({
    societyId,
    partnerId: '',
    categoryId: '',
    page: 1,
    items: MAX_PARTNERS_BY_DRAFTS,
  });

  useEffect(() => {
    if (societyId) {
      dispatch(getHoldingClasses({ societyId }));
      dispatch(getStockPlans(societyId));
      dispatch(getTenderOffers(societyId));
    }
  }, [societyId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (societyId && !drafts?.length) {
      dispatch(getDrafts(societyId));
    }
  }, [societyId, drafts]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    data: {
      actualSociety,
      drafts,
      holdingClasses,
      investors,
      operations,
      partners,
      plans,
      tenderOffers,
    },
    isLoading: false,
    isError: false,
  };
};

export default useDraftSellParticipations;
